import React from 'react'
import ScrollAnimation from 'react-animate-on-scroll'
import BannerHolder from './Banner/BannerHolder'
import Banner from './Banner/Banner'
import About from './About'
import Skills from './Skills'
import Projects from './Projects'
import Contact from './Contact'
import Naavbar from './Navbar'

class Container extends React.Component{
    render(){
        return(
            <>
            <Naavbar/>
            <BannerHolder bannerclass='bannerHolder'>
                <Banner/>
            </BannerHolder>
            <About/>
            <ScrollAnimation
            delay = {400}
            animateIn = 'bounceInRight'
            animateOut="wobble">
                <Skills/>
            </ScrollAnimation>
            <ScrollAnimation
            delay = {400}
            animateIn = 'wobble'
            animateOut="fadeOut">
                <Projects/>
            </ScrollAnimation>
            <Contact/>
            </>
        )
    }
}

export default Container